<template>
  <div class="page">
    <Loader v-if="loader" />
    <div class="card">
      <DataTable :value="clienti">
        <Column v-for="col of columns" :key="col.field" :field="col.field" :header="col.header">
          <template #body="{data}">
            <InlineMessage v-if="col.field == 'esito'" :severity="getSeverity(data.sdiUpdated)">{{data.esito}}</InlineMessage>
            <div v-else-if="col.field == 'ragsoc'">
              <div v-if="data.cod_type_client == 2">
                {{ data.cognome }} {{ data.nome }}
              </div>
              <div v-else>
                {{ data[col.field] }}
              </div>
            </div>
            <div v-else>
              {{ data[col.field] }}
            </div>
          </template>
        </Column>
      </DataTable>
    </div>

    <div v-if="!updated">
      <div class="card flex justify-content-center m-3">
        <div class="flex flex-column">
          <label class="mb-2"><strong>Seleziona SDI</strong></label>
          <Dropdown v-model="selectedSdi" :options="sdi" placeholder="Seleziona" :filter="true" :showClear="true" optionLabel="sdi" optionValue="sdi"/>
        </div>
      </div>
      <div class="flex justify-content-center m-3">
        <Button v-if="selectedSdi" label="Associa codice Sdi" class="p-button-success" @click="setMassivoSdi()"/>
      </div>
    </div>
  </div>
</template>

<script>
import Service from '@/services/ask-management/clienti-service'
import Loader from '@/components/Loader.vue'
import { ref, getCurrentInstance, onMounted } from "vue";
import { useToast } from 'primevue/usetoast';

export default {
  props: {
    data: {
      type: Array,
      required: true
    }
  },
  components: {
    Loader
  },
  setup(props){
    const toast = useToast();
    const clienti = ref(props.data)
    const columns = ref([
      {field:'ragsoc', header:'Denominazione'},
      {field:'codiceDestinatario', header:'Codice Sdi'}
    ])
    const updated = ref(false)
    const loader = ref(false)
    const names = ref(props.data.names)
    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus;
    self.$http = self.appContext.config.globalProperties.$http;
    const service = new Service(self.$http, self.$eventBus);
    const sdi = ref([])
    const selectedSdi = ref()
    const getSdi = async () => {
      loader.value = true
      await service.getSDI()
      .then((res) => {
        sdi.value = res.items
      })
      .finally(()=>{
        loader.value = false
      })
    }
    const severity = ref(['error', 'success'])

    const setMassivoSdi = async () => {
      loader.value = true
      await service.setMassivoSDI(clienti.value, selectedSdi.value)
      .then((res) => {
        let detail = res.items.msg
        let severity = res.items.success ? 'success' : 'danger'
        if (res.items.success) {
          clienti.value = res.items.clienti
          columns.value.push({field:'nuovoCodiceDestinatario', header: 'Nuovo codice Sdi'})
          columns.value.push({field:'esito', header: 'Esito aggiornamento SDI'})
          updated.value = true
        }
        toast.add({severity: severity, detail: detail})
      })
      .finally(()=>{
        loader.value = false
      })
    }
    onMounted(()=>{      
      Promise.all([getSdi()])
    })

    const getSeverity = (is_updated) => {
      return severity.value[is_updated]
    }

    return {
      toast,
      service,
      names,
      loader,
      sdi,
      selectedSdi,
      setMassivoSdi,
      clienti,
      columns,
      updated,
      getSeverity,
    }
  }
}
</script>

<style>

</style>
